

const APIBaseUrl ='https://devapi.instagyfts.com/api/v1/'
const RestServices = {
    // User API///


    validatePhone: function (bodyData) {
        const APIoptions = {
            method: 'POST',
            headers: new Headers({
                Accept: 'application/json',
                'Content-Type': 'application/json'
            }),
            body: JSON.stringify(bodyData)
        };
        return fetch(APIBaseUrl + 'profiles/validate_phone', APIoptions);
    },

    validatePhoneOTP: function (bodyData) {
        const APIoptions = {
            method: 'POST',
            headers: new Headers({
                Accept: 'application/json',
                'Content-Type': 'application/json'
            }),
            body: JSON.stringify(bodyData)
        };
        return fetch(APIBaseUrl + 'profiles/validate_phone_otp', APIoptions);
    },

    doLogOut: function (bodyData) {
        const APIoptions = {
            method: 'POST',
            headers: new Headers({
                Accept: 'application/json',
                'Content-Type': 'application/json'
            }),
            body: JSON.stringify(bodyData)
        };
        return fetch(APIBaseUrl + 'profiles/logOut', APIoptions);
    },

    /*////////////////////////////////////////////////////////*/
    /*///////////////      Global API      ///////////////*/
    /*////////////////////////////////////////////////////////*/

    GlobalPost: function (FirebaseToken, bodyData, functionname) {
        const APIoptions = {
            method: 'POST',
            headers: new Headers({
                Accept: 'application/json',
                'Content-Type': 'application/json',
                Authorization: 'Bearer ' + FirebaseToken
            }),
            body: JSON.stringify(bodyData)
        };
        return fetch(APIBaseUrl + functionname, APIoptions);
    },

    GlobalGet: function (FirebaseToken, functionname) {
        const APIoptions = {
            method: 'GET',
            headers: new Headers({
                Accept: 'application/json',
                'Content-Type': 'application/json',
                Authorization: 'Bearer ' + FirebaseToken
            })
        };
        return fetch(APIBaseUrl + functionname, APIoptions);
    },

    /*////////////////////////////////////////////////////////*/
    /*///////////////      Get API BaseURL     ///////////////*/
    /*////////////////////////////////////////////////////////*/

    getServerBaseURL: function () {
        return APIBaseUrl;
    },

    /*////////////////////////////////////////////////////////*/
    /*/////////////// Admin Global Configuration related API///////////////*/
    /*////////////////////////////////////////////////////////*/
    getAllMasterGiftCards: function (FirebaseToken, bodyData) {
        const APIoptions = {
            method: 'POST',
            headers: new Headers({
                Accept: 'application/json',
                'Content-Type': 'application/json',
                Authorization: 'Bearer ' + FirebaseToken
            }),
            body: JSON.stringify(bodyData)
        };
        return fetch(
            APIBaseUrl + 'configuration/GetMasterGiftCards',
            APIoptions
        );
    },

    updateMasterGiftCard: function (FirebaseToken, bodyData) {
        const APIoptions = {
            method: 'POST',
            headers: new Headers({
                Accept: 'application/json',
                'Content-Type': 'application/json',
                Authorization: 'Bearer ' + FirebaseToken
            }),
            body: JSON.stringify(bodyData)
        };
        return fetch(
            APIBaseUrl + 'configuration/updateMasterGiftCard',
            APIoptions
        );
    },

    deleteMasterGiftCards: function (FirebaseToken, bodyData) {
        const APIoptions = {
            method: 'POST',
            headers: new Headers({
                Accept: 'application/json',
                'Content-Type': 'application/json',
                Authorization: 'Bearer ' + FirebaseToken
            }),
            body: JSON.stringify(bodyData)
        };
        return fetch(
            APIBaseUrl + 'configuration/deleteMasterGiftCards',
            APIoptions
        );
    },

    getAllCommission: function (FirebaseToken) {
        const APIoptions = {
            method: 'GET',
            headers: new Headers({
                Accept: 'application/json',
                'Content-Type': 'application/json',
                Authorization: 'Bearer ' + FirebaseToken
            })
        };
        return fetch(APIBaseUrl + 'configuration/getAllCommission', APIoptions);
    },

    updateAllCommission: function (FirebaseToken, bodyData) {
        const APIoptions = {
            method: 'POST',
            headers: new Headers({
                Accept: 'application/json',
                'Content-Type': 'application/json',
                Authorization: 'Bearer ' + FirebaseToken
            }),
            body: JSON.stringify(bodyData)
        };
        return fetch(
            APIBaseUrl + 'configuration/updateAllCommission',
            APIoptions
        );
    },

    /*////////////////////////////////////////////////////////*/
    /*/////////////// Users GiftCard related API///////////////*/
    /*////////////////////////////////////////////////////////*/

    getBearerToken: function (FirebaseToken) {
        const APIoptions = {
            method: 'GET',
            headers: new Headers({
                Accept: 'application/json',
                'Content-Type': 'application/json',
                Authorization: 'Bearer ' + FirebaseToken
            })
        };

        return fetch(APIBaseUrl + 'woohoo/getBearerToken', APIoptions);
    },

    updateWoohooProductsDB: function (FirebaseToken, bodyData) {
        const APIoptions = {
            method: 'POST',
            headers: new Headers({
                Accept: 'application/json',
                'Content-Type': 'application/json',
                Authorization: 'Bearer ' + FirebaseToken
            }),
            body: JSON.stringify(bodyData)
        };

        return fetch(APIBaseUrl + 'woohoo/updateWoohooProductsDB', APIoptions);
    },

    updateWoohooCatProductsDB: function (FirebaseToken, bodyData, catID) {
        const APIoptions = {
            method: 'POST',
            headers: new Headers({
                Accept: 'application/json',
                'Content-Type': 'application/json',
                Authorization: 'Bearer ' + FirebaseToken
            }),
            body: JSON.stringify(bodyData)
        };

        return fetch(
            APIBaseUrl + 'woohoo/updateWoohooCatProductsDB?catId=' + catID,
            APIoptions
        );
    },

    updateWoohooProductDetailDB: function (
        FirebaseToken,
        bodyData,
        productSKU
    ) {
        const APIoptions = {
            method: 'POST',
            headers: new Headers({
                Accept: 'application/json',
                'Content-Type': 'application/json',
                Authorization: 'Bearer ' + FirebaseToken
            }),
            body: JSON.stringify(bodyData)
        };

        return fetch(
            APIBaseUrl +
                'woohoo/updateWoohooProductDetailDB?productSKU=' +
                productSKU,
            APIoptions
        );
    },

    getMyGiftCards: function (FirebaseToken, bodyData) {
        const APIoptions = {
            method: 'POST',
            headers: new Headers({
                Accept: 'application/json',
                'Content-Type': 'application/json',
                Authorization: 'Bearer ' + FirebaseToken
            }),
            body: JSON.stringify(bodyData)
        };

        return fetch(APIBaseUrl + 'woohoo/getMyGiftCards', APIoptions);
    },

    /*////////////////////////////////////////////////////////*/
    /*/////////////// RazorPay related API///////////////*/
    /*////////////////////////////////////////////////////////*/

    RazorPayNewOrder: function (FirebaseToken, bodyData) {
        const APIoptions = {
            method: 'POST',
            headers: new Headers({
                Accept: 'application/json',
                'Content-Type': 'application/json',
                Authorization: 'Bearer ' + FirebaseToken
            }),
            body: JSON.stringify(bodyData)
        };

        return fetch(APIBaseUrl + 'razorpay/createorder', APIoptions);
    },

    RazorPayNewOrderLink: function (FirebaseToken, bodyData) {
        const APIoptions = {
            method: 'POST',
            headers: new Headers({
                Accept: 'application/json',
                'Content-Type': 'application/json',
                Authorization: 'Bearer ' + FirebaseToken
            }),
            body: JSON.stringify(bodyData)
        };

        return fetch(APIBaseUrl + 'razorpay/createorderlink', APIoptions);
    },

    getRazorPayOrderStatus: function (bodyData) {
        const APIoptions = {
            method: 'POST',
            headers: new Headers({
                Accept: 'application/json',
                'Content-Type': 'application/json'
            }),
            body: JSON.stringify(bodyData)
        };

        return fetch(APIBaseUrl + 'razorpay/getOrderStatus', APIoptions);
    },

    /*////////////////////////////////////////////////////////*/
    /*/////////////// Users Wallet related API///////////////*/
    /*////////////////////////////////////////////////////////*/

    createPayJiOrder: function (FirebaseToken, bodyData) {
        const APIoptions = {
            method: 'POST',
            headers: new Headers({
                Accept: 'application/json',
                'Content-Type': 'application/json',
                Authorization: 'Bearer ' + FirebaseToken
            }),
            body: JSON.stringify(bodyData)
        };
        return fetch(APIBaseUrl + 'cashfree/createPayJiOrder', APIoptions);
    },

    getBeneficialDetail: function (FirebaseToken, bodyData) {
        const APIoptions = {
            method: 'POST',
            headers: new Headers({
                Accept: 'application/json',
                'Content-Type': 'application/json',
                Authorization: 'Bearer ' + FirebaseToken
            }),
            body: JSON.stringify(bodyData)
        };
        return fetch(APIBaseUrl + 'cashfree/getBeneficialDetail', APIoptions);
    },

    addBeneficialDetail: function (FirebaseToken, bodyData) {
        const APIoptions = {
            method: 'POST',
            headers: new Headers({
                Accept: 'application/json',
                'Content-Type': 'application/json',
                Authorization: 'Bearer ' + FirebaseToken
            }),
            body: JSON.stringify(bodyData)
        };

        return fetch(APIBaseUrl + 'cashfree/addBeneficialDetail', APIoptions);
    },

    getAllCashFreeTransaction: function (FirebaseToken, bodyData) {
        const APIoptions = {
            method: 'POST',
            headers: new Headers({
                Accept: 'application/json',
                'Content-Type': 'application/json',
                Authorization: 'Bearer ' + FirebaseToken
            }),
            body: JSON.stringify(bodyData)
        };

        return fetch(
            APIBaseUrl + 'cashfree/getAllCashFreeTransaction',
            APIoptions
        );
    },

    getAllCashFreeLinks: function (FirebaseToken, bodyData) {
        const APIoptions = {
            method: 'POST',
            headers: new Headers({
                Accept: 'application/json',
                'Content-Type': 'application/json',
                Authorization: 'Bearer ' + FirebaseToken
            }),
            body: JSON.stringify(bodyData)
        };

        return fetch(APIBaseUrl + 'cashfree/getAllCashFreeLinks', APIoptions);
    },

    requestBankTransfer: function (FirebaseToken, bodyData) {
        const APIoptions = {
            method: 'POST',
            headers: new Headers({
                Accept: 'application/json',
                'Content-Type': 'application/json',
                Authorization: 'Bearer ' + FirebaseToken
            }),
            body: JSON.stringify(bodyData)
        };

        return fetch(
            APIBaseUrl + 'cashfree/cashFreeRequestTransfer',
            APIoptions
        );
    },

    getPaymentLink: function (FirebaseToken, bodyData) {
        const APIoptions = {
            method: 'POST',
            headers: new Headers({
                Accept: 'application/json',
                'Content-Type': 'application/json',
                Authorization: 'Bearer ' + FirebaseToken
            }),
            body: JSON.stringify(bodyData)
        };

        return fetch(APIBaseUrl + 'cashfree/getPaymentLink', APIoptions);
    },

    createNewOrderLink: function (FirebaseToken, bodyData) {
        const APIoptions = {
            method: 'POST',
            headers: new Headers({
                Accept: 'application/json',
                'Content-Type': 'application/json',
                Authorization: 'Bearer ' + FirebaseToken
            }),
            body: JSON.stringify(bodyData)
        };

        return fetch(APIBaseUrl + 'cashfree/createNewOrderLink', APIoptions);
    },

    getOrderStatus: function (bodyData) {
        const APIoptions = {
            method: 'POST',
            headers: new Headers({
                Accept: 'application/json',
                'Content-Type': 'application/json'
            }),
            body: JSON.stringify(bodyData)
        };

        return fetch(APIBaseUrl + 'cashfree/getOrderStatus', APIoptions);
    },

    getCashFreeLinkStatus: function (bodyData) {
        const APIoptions = {
            method: 'POST',
            headers: new Headers({
                Accept: 'application/json',
                'Content-Type': 'application/json'
            }),
            body: JSON.stringify(bodyData)
        };
        return fetch(APIBaseUrl + 'cashfree/getCashFreeLinkStatus', APIoptions);
    },
    getRazorPayLinkStatus: function (bodyData) {
        const APIoptions = {
            method: 'POST',
            headers: new Headers({
                Accept: 'application/json',
                'Content-Type': 'application/json'
            }),
            body: JSON.stringify(bodyData)
        };
        return fetch(APIBaseUrl + 'cashfree/getRazorPayLinkStatus', APIoptions);
    },

    getLinkPayments: function (bodyData) {
        const APIoptions = {
            method: 'POST',
            headers: new Headers({
                Accept: 'application/json',
                'Content-Type': 'application/json'
            }),
            body: JSON.stringify(bodyData)
        };
        return fetch(APIBaseUrl + 'cashfree/getLinkPayments', APIoptions);
    },

    updateCashFreeWalletLink: function (bodyData) {
        const APIoptions = {
            method: 'POST',
            headers: new Headers({
                Accept: 'application/json',
                'Content-Type': 'application/json'
            }),
            body: JSON.stringify(bodyData)
        };
        return fetch(
            APIBaseUrl + 'cashfree/updateCashFreeWalletLink',
            APIoptions
        );
    },

    updateCashFreeWallet: function (FirebaseToken, bodyData) {
        const APIoptions = {
            method: 'POST',
            headers: new Headers({
                Accept: 'application/json',
                'Content-Type': 'application/json',
                Authorization: 'Bearer ' + FirebaseToken
            }),
            body: JSON.stringify(bodyData)
        };
        return fetch(APIBaseUrl + 'cashfree/updateCashFreeWallet', APIoptions);
    },

    /*/////////////// Users Wallet related API///////////////*/
    /*////////////////////////////////////////////////////////*/

    updateDashboardDataStatics: function (FirebaseToken) {
        const APIoptions = {
            method: 'GET',
            headers: new Headers({
                Accept: 'application/json',
                'Content-Type': 'application/json',
                Authorization: 'Bearer ' + FirebaseToken
            })
        };

        return fetch(
            APIBaseUrl + 'dashboardmg/updateDashboardData',
            APIoptions
        );
    },

    getPosRequests: function (FirebaseToken) {
        const APIoptions = {
            method: 'GET',
            headers: new Headers({
                Accept: 'application/json',
                'Content-Type': 'application/json',
                Authorization: 'Bearer ' + FirebaseToken
            })
        };

        return fetch(APIBaseUrl + 'user/getPosRequests', APIoptions);
    },

    ApplyNewPOS: function (FirebaseToken, bodyData, DocumentId) {
        const APIoptions = {
            method: 'POST',
            headers: new Headers({
                Accept: 'application/json',
                'Content-Type': 'application/json',
                Authorization: 'Bearer ' + FirebaseToken
            }),
            body: JSON.stringify(bodyData)
        };
        return fetch(
            APIBaseUrl + 'user/ApplyNewPOS?DocumentId=' + DocumentId,
            APIoptions
        );
    },

    getReferralData: function (FirebaseToken, bodyData) {
        const APIoptions = {
            method: 'POST',
            headers: new Headers({
                Accept: 'application/json',
                'Content-Type': 'application/json',
                Authorization: 'Bearer ' + FirebaseToken
            }),
            body: JSON.stringify(bodyData)
        };

        return fetch(APIBaseUrl + 'user/getReferralData', APIoptions);
    },

    addNewRefferal: function (FirebaseToken, bodyData) {
        const APIoptions = {
            method: 'POST',
            headers: new Headers({
                Accept: 'application/json',
                'Content-Type': 'application/json',
                Authorization: 'Bearer ' + FirebaseToken
            }),
            body: JSON.stringify(bodyData)
        };

        return fetch(APIBaseUrl + 'user/addNewRefferal', APIoptions);
    },

    /////////////////////////********Royalty Screen API********////////////////////////
    //////////////////////********Developer Raman Bhasker********//////////////////////

    getRoyalty: function (FirebaseToken) {
        const APIoptions = {
            method: 'GET',
            headers: new Headers({
                Accept: 'application/json',
                'Content-Type': 'application/json',
                Authorization: 'Bearer ' + FirebaseToken
            })
        };
        return fetch(APIBaseUrl + 'royalty/getAll', APIoptions);
    },

    deleteRoyalty: function (FirebaseToken, storeGroup) {
        const APIoptions = {
            method: 'GET',
            headers: new Headers({
                Accept: 'application/json',
                'Content-Type': 'application/json',
                Authorization: 'Bearer ' + FirebaseToken
            })
        };
        return fetch(
            APIBaseUrl + 'royalty/deleteRoyalty?storeGroup=' + storeGroup,
            APIoptions
        );
    },

    updateRoyalty: function (FirebaseToken, oldStoreGroup, newData) {
        const APIoptions = {
            method: 'POST',
            headers: new Headers({
                Accept: 'application/json',
                'Content-Type': 'application/json',
                Authorization: 'Bearer ' + FirebaseToken
            }),
            body: JSON.stringify(newData)
        };
        return fetch(
            APIBaseUrl + 'royalty/updateRoyalty?oldStoreGroup=' + oldStoreGroup,
            APIoptions
        );
    },

    updateDeleteRoyalty: function (FirebaseToken, oldStoreGroup, newData) {
        const APIoptions = {
            method: 'POST',
            headers: new Headers({
                Accept: 'application/json',
                'Content-Type': 'application/json',
                Authorization: 'Bearer ' + FirebaseToken
            }),
            body: JSON.stringify(newData)
        };
        return fetch(
            APIBaseUrl +
                'royalty/updateDeleteRoyalty?oldStoreGroup=' +
                oldStoreGroup,
            APIoptions
        );
    },

    /////////////////////////********Storetags Realted  API********////////////////////////
    //////////////////////********Developer Raman Bhasker********//////////////////////

    importStoreTagMapping: function (FirebaseToken, bodyData) {
        const APIoptions = {
            method: 'POST',
            headers: new Headers({
                Accept: 'application/json',
                'Content-Type': 'application/json',
                Authorization: 'Bearer ' + FirebaseToken
            }),
            body: JSON.stringify(bodyData)
        };
        return fetch(
            APIBaseUrl + 'storetags/importStoreTagMapping',
            APIoptions
        );
    },
    forceimportStoreTagMapping: function (FirebaseToken, bodyData) {
        const APIoptions = {
            method: 'POST',
            headers: new Headers({
                Accept: 'application/json',
                'Content-Type': 'application/json',
                Authorization: 'Bearer ' + FirebaseToken
            }),
            body: JSON.stringify(bodyData)
        };
        return fetch(
            APIBaseUrl + 'storetags/forceimportStoreTagMapping',
            APIoptions
        );
    },

    getAllStoresEmailMappedWith: function (FirebaseToken, bodyData) {
        const APIoptions = {
            method: 'POST',
            headers: new Headers({
                Accept: 'application/json',
                'Content-Type': 'application/json',
                Authorization: 'Bearer ' + FirebaseToken
            }),
            body: JSON.stringify(bodyData)
        };
        return fetch(
            APIBaseUrl + 'storetags/getAllStoresEmailMappedWith',
            APIoptions
        );
    },

    getAllStoresMappedWith: function (FirebaseToken, UniqeID, userRole) {
        const APIoptions = {
            method: 'GET',
            headers: new Headers({
                Accept: 'application/json',
                'Content-Type': 'application/json',
                Authorization: 'Bearer ' + FirebaseToken
            })
        };
        return fetch(
            APIBaseUrl +
                'storetags/getAllStoresMappedWith?userRole=' +
                userRole +
                '&UniqeID=' +
                UniqeID,
            APIoptions
        );
    },

    getStoreTagMapped: function (FirebaseToken, bodyData) {
        const APIoptions = {
            method: 'POST',
            headers: new Headers({
                Accept: 'application/json',
                'Content-Type': 'application/json',
                Authorization: 'Bearer ' + FirebaseToken
            }),
            body: JSON.stringify(bodyData)
        };

        return fetch(APIBaseUrl + 'storetags/getStoreTagMapped', APIoptions);
    },

    getStoreTagMappingHistory: function (FirebaseToken, bodyData) {
        const APIoptions = {
            method: 'POST',
            headers: new Headers({
                Accept: 'application/json',
                'Content-Type': 'application/json',
                Authorization: 'Bearer ' + FirebaseToken
            }),
            body: JSON.stringify(bodyData)
        };

        return fetch(
            APIBaseUrl + 'storetags/getStoreTagMappingHistory',
            APIoptions
        );
    },

    deleteStoreTag: function (FirebaseToken, bodyData) {
        const APIoptions = {
            method: 'POST',
            headers: new Headers({
                Accept: 'application/json',
                'Content-Type': 'application/json',
                Authorization: 'Bearer ' + FirebaseToken
            }),
            body: JSON.stringify(bodyData)
        };
        return fetch(APIBaseUrl + 'storetags/deleteStoreTag', APIoptions);
    },

    getStoreTagsMappingPaginate: function (FirebaseToken, bodyData) {
        const APIoptions = {
            method: 'POST',
            headers: new Headers({
                Accept: 'application/json',
                'Content-Type': 'application/json',
                Authorization: 'Bearer ' + FirebaseToken
            }),
            body: JSON.stringify(bodyData)
        };
        return fetch(
            APIBaseUrl + 'storetags/getStoreTagsMappingPaginate',
            APIoptions
        );
    },

    getStoreTagDetail: function (FirebaseToken, bodyData) {
        const APIoptions = {
            method: 'POST',
            headers: new Headers({
                Accept: 'application/json',
                'Content-Type': 'application/json',
                Authorization: 'Bearer ' + FirebaseToken
            }),
            body: JSON.stringify(bodyData)
        };
        return fetch(APIBaseUrl + 'storetags/getStoreTagDetail', APIoptions);
    },

    SearchStoreTagsMapping: function (FirebaseToken, bodyData) {
        const APIoptions = {
            method: 'POST',
            headers: new Headers({
                Accept: 'application/json',
                'Content-Type': 'application/json',
                Authorization: 'Bearer ' + FirebaseToken
            }),
            body: JSON.stringify(bodyData)
        };
        return fetch(
            APIBaseUrl + 'storetags/SearchStoreTagsMapping',
            APIoptions
        );
    },

    getStoreTagsMapping: function (FirebaseToken, UniqeID, userRole) {
        const APIoptions = {
            method: 'GET',
            headers: new Headers({
                Accept: 'application/json',
                'Content-Type': 'application/json',
                Authorization: 'Bearer ' + FirebaseToken
            })
        };
        return fetch(
            APIBaseUrl +
                'storetags/getStoreTagsMapping?userRole=' +
                userRole +
                '&UniqeID=' +
                UniqeID,
            APIoptions
        );
    },
    getStoreTagsOwners: function (FirebaseToken) {
        const APIoptions = {
            method: 'GET',
            headers: new Headers({
                Accept: 'application/json',
                'Content-Type': 'application/json',
                Authorization: 'Bearer ' + FirebaseToken
            })
        };
        return fetch(APIBaseUrl + 'storetags/getStoreTagsOwners', APIoptions);
    },

    getAvaliableStoreTags: function (FirebaseToken, language) {
        const APIoptions = {
            method: 'GET',
            headers: new Headers({
                Accept: 'application/json',
                'Content-Type': 'application/json',
                Authorization: 'Bearer ' + FirebaseToken
            })
        };
        return fetch(
            APIBaseUrl + 'storetags/getAvaliableStoreTags',
            APIoptions
        );
    },

    addAvaliableStoreTag: function (FirebaseToken, bodyData) {
        const APIoptions = {
            method: 'POST',
            headers: new Headers({
                Accept: 'application/json',
                'Content-Type': 'application/json',
                Authorization: 'Bearer ' + FirebaseToken
            }),
            body: JSON.stringify(bodyData)
        };
        return fetch(APIBaseUrl + 'storetags/addAvaliableStoreTag', APIoptions);
    },

    updateDeleteAvaliableStoreTag: function (
        FirebaseToken,
        oldStoreGroup,
        newData
    ) {
        const APIoptions = {
            method: 'POST',
            headers: new Headers({
                Accept: 'application/json',
                'Content-Type': 'application/json',
                Authorization: 'Bearer ' + FirebaseToken
            }),
            body: JSON.stringify(newData)
        };
        return fetch(
            APIBaseUrl + 'storetags/updateDeleteAvaliableStoreTag',
            APIoptions
        );
    },

    getAllStoreTags: function (FirebaseToken) {
        const APIoptions = {
            method: 'GET',
            headers: new Headers({
                Accept: 'application/json',
                'Content-Type': 'application/json',
                Authorization: 'Bearer ' + FirebaseToken
            })
        };
        return fetch(APIBaseUrl + 'storetags/getAll', APIoptions);
    },

    getSheets: function (FirebaseToken, scheduled) {
        const APIoptions = {
            method: 'GET',
            headers: new Headers({
                Accept: 'application/json',
                'Content-Type': 'application/json',
                Authorization: 'Bearer ' + FirebaseToken
            })
        };
        return fetch(
            APIBaseUrl + 'storetags/getAllSheets?scheduled=' + scheduled,
            APIoptions
        );
    },

    /////////////////////////********incentives Screen API********////////////////////////
    //////////////////////********Developer Raman Bhasker********//////////////////////

    getStoreIncentives: function (FirebaseToken, incentivesDoc, sheetName) {
        const APIoptions = {
            method: 'GET',
            headers: new Headers({
                Accept: 'application/json',
                'Content-Type': 'application/json',
                Authorization: 'Bearer ' + FirebaseToken
            })
        };
        return fetch(
            APIBaseUrl +
                'incentives/getAll?incentivesDoc=' +
                incentivesDoc +
                '&sheetName=' +
                sheetName,
            APIoptions
        );
    },

    getIncentivesMetadata: function (FirebaseToken, scheduled, sheetName) {
        const APIoptions = {
            method: 'GET',
            headers: new Headers({
                Accept: 'application/json',
                'Content-Type': 'application/json',
                Authorization: 'Bearer ' + FirebaseToken
            })
        };
        return fetch(
            APIBaseUrl +
                'incentives/getMetadata?scheduled=' +
                scheduled +
                '&sheetName=' +
                sheetName,
            APIoptions
        );
    },

    checkIfSheetUploaded: function (FirebaseToken, scheduled) {
        const APIoptions = {
            method: 'GET',
            headers: new Headers({
                Accept: 'application/json',
                'Content-Type': 'application/json',
                Authorization: 'Bearer ' + FirebaseToken
            })
        };
        return fetch(
            APIBaseUrl +
                'incentives/checkIfSheetUploaded?scheduled=' +
                scheduled,
            APIoptions
        );
    },
    getPreviousSheetData: function (FirebaseToken, scheduled) {
        const APIoptions = {
            method: 'GET',
            headers: new Headers({
                Accept: 'application/json',
                'Content-Type': 'application/json',
                Authorization: 'Bearer ' + FirebaseToken
            })
        };
        return fetch(
            APIBaseUrl +
                'incentives/getPreviousSheetData?scheduled=' +
                scheduled,
            APIoptions
        );
    },

    getAllStoreIncentives: function (FirebaseToken, dbCollection, docId) {
        const APIoptions = {
            method: 'GET',
            headers: new Headers({
                Accept: 'application/json',
                'Content-Type': 'application/json',
                Authorization: 'Bearer ' + FirebaseToken
            })
        };
        return fetch(
            APIBaseUrl +
                'incentives/getAllStoreIncentives?dbCollection=' +
                dbCollection +
                '&docId=' +
                docId,
            APIoptions
        );
    },

    approvePublishIncentives: function (FirebaseToken, scheduled) {
        const APIoptions = {
            method: 'GET',
            headers: new Headers({
                Accept: 'application/json',
                'Content-Type': 'application/json',
                Authorization: 'Bearer ' + FirebaseToken
            })
        };
        return fetch(
            APIBaseUrl +
                'incentives/approvePublishIncentives?scheduled=' +
                scheduled,
            APIoptions
        );
    },

    getAllStoreWallet: function (FirebaseToken, key) {
        const APIoptions = {
            method: 'GET',
            headers: new Headers({
                Accept: 'application/json',
                'Content-Type': 'application/json',
                Authorization: 'Bearer ' + FirebaseToken
            })
        };
        return fetch(
            APIBaseUrl + 'incentives/getAllStoreWallet?key=' + key,
            APIoptions
        );
    },

    updateWalletTransactionHistory: function (
        FirebaseToken,
        key,
        currentBalance,
        calculatedAmount
    ) {
        const APIoptions = {
            method: 'GET',
            headers: new Headers({
                Accept: 'application/json',
                'Content-Type': 'application/json',
                Authorization: 'Bearer ' + FirebaseToken
            })
        };
        return fetch(
            APIBaseUrl +
                'incentives/updateWalletTransactionHistory?key=' +
                key +
                '&currentBalance=' +
                currentBalance +
                '&calculatedAmount=' +
                calculatedAmount,
            APIoptions
        );
    },

    UpdateStoreIncentivesUpdationDates: function (
        FirebaseToken,
        scheduled,
        bodyData
    ) {
        const APIoptions = {
            method: 'GET',
            headers: new Headers({
                Accept: 'application/json',
                'Content-Type': 'application/json',
                Authorization: 'Bearer ' + FirebaseToken
            })
        };
        return fetch(
            APIBaseUrl +
                'incentives/UpdateStoreIncentivesUpdationDates?scheduled=' +
                scheduled +
                '&bodyData=' +
                bodyData,
            APIoptions
        );
    },

    updateIncentivesMetadata: function (
        FirebaseToken,
        scheduled,
        did,
        bodyData
    ) {
        const APIoptions = {
            method: 'POST',
            headers: new Headers({
                Accept: 'application/json',
                'Content-Type': 'application/json',
                Authorization: 'Bearer ' + FirebaseToken
            }),
            body: bodyData
        };
        return fetch(
            APIBaseUrl +
                'incentives/updateIncentivesMetadata?scheduled=' +
                scheduled +
                '&did=' +
                did,
            APIoptions
        );
    },

    updateStoreIncentives: function (FirebaseToken, docId, bodyData) {
        const APIoptions = {
            method: 'POST',
            headers: new Headers({
                Accept: 'application/json',
                'Content-Type': 'application/json',
                Authorization: 'Bearer ' + FirebaseToken
            }),
            body: bodyData
        };
        return fetch(
            APIBaseUrl + 'incentives/updateStoreIncentives?docId=' + docId,
            APIoptions
        );
    },

    getWalletTransactionHistory: function (FirebaseToken, storeTag) {
        const APIoptions = {
            method: 'GET',
            headers: new Headers({
                Accept: 'application/json',
                'Content-Type': 'application/json',
                Authorization: 'Bearer ' + FirebaseToken
            })
        };
        return fetch(
            APIBaseUrl +
                'incentives/getWalletTransactionHistory?storeTag=' +
                storeTag,
            APIoptions
        );
    },

    getStoreWallet: function (FirebaseToken, storeTag) {
        const APIoptions = {
            method: 'GET',
            headers: new Headers({
                Accept: 'application/json',
                'Content-Type': 'application/json',
                Authorization: 'Bearer ' + FirebaseToken
            })
        };
        return fetch(
            APIBaseUrl + 'incentives/getStoreWallet?storeTag=' + storeTag,
            APIoptions
        );
    },

    releasePaymentFromWallet: function (
        FirebaseToken,
        storeTag,
        currentBalance,
        inputAmount
    ) {
        const APIoptions = {
            method: 'GET',
            headers: new Headers({
                Accept: 'application/json',
                'Content-Type': 'application/json',
                Authorization: 'Bearer ' + FirebaseToken
            })
        };
        return fetch(
            APIBaseUrl +
                'incentives/releasePaymentFromWallet?storeTag=' +
                storeTag +
                '&currentBalance=' +
                currentBalance +
                '&inputAmount=' +
                inputAmount,
            APIoptions
        );
    },

    /////////////////////////********Banners Screen API********////////////////////////
    //////////////////////********Developer Raman Bhasker********//////////////////////

    getSliderImages: function (FirebaseToken) {
        const APIoptions = {
            method: 'GET',
            headers: new Headers({
                Accept: 'application/json',
                'Content-Type': 'application/json',
                Authorization: 'Bearer ' + FirebaseToken
            })
        };
        return fetch(APIBaseUrl + 'banners/getSliderImages', APIoptions);
    },
    getSliderImagesList: function (FirebaseToken) {
        const APIoptions = {
            method: 'GET',
            headers: new Headers({
                Accept: 'application/json',
                'Content-Type': 'application/json',
                Authorization: 'Bearer ' + FirebaseToken
            })
        };
        return fetch(APIBaseUrl + 'banners/getSliderImagesList', APIoptions);
    },

    deleteSliderImages: function (FirebaseToken, bodyData) {
        const APIoptions = {
            method: 'POST',
            headers: new Headers({
                Accept: 'application/json',
                'Content-Type': 'application/json',
                Authorization: 'Bearer ' + FirebaseToken
            }),
            body: JSON.stringify(bodyData)
        };
        return fetch(APIBaseUrl + 'banners/deleteSliderImages', APIoptions);
    },
    updateSliderImages: function (FirebaseToken, bodyData) {
        const APIoptions = {
            method: 'POST',
            headers: new Headers({
                Accept: 'application/json',
                'Content-Type': 'application/json',
                Authorization: 'Bearer ' + FirebaseToken
            }),
            body: JSON.stringify(bodyData)
        };
        return fetch(APIBaseUrl + 'banners/updateSliderImages', APIoptions);
    },

    /***** Profiles Section Start Here **************/
    allProfilesWallets: function (FirebaseToken, bodyData) {
        const APIoptions = {
            method: 'POST',
            headers: new Headers({
                Accept: 'application/json',
                'Content-Type': 'application/json',
                Authorization: 'Bearer ' + FirebaseToken
            }),
            body: JSON.stringify(bodyData)
        };

        return fetch(APIBaseUrl + 'profiles/allProfilesWallets', APIoptions);
    },

    getTotalProfileCount: function (FirebaseToken, bodyData) {
        const APIoptions = {
            method: 'POST',
            headers: new Headers({
                Accept: 'application/json',
                'Content-Type': 'application/json',
                Authorization: 'Bearer ' + FirebaseToken
            }),
            body: JSON.stringify(bodyData)
        };

        return fetch(APIBaseUrl + 'profiles/getTotalProfileCount', APIoptions);
    },

    getAllProfilesPagination: function (FirebaseToken, bodyData) {
        const APIoptions = {
            method: 'POST',
            headers: new Headers({
                Accept: 'application/json',
                'Content-Type': 'application/json',
                Authorization: 'Bearer ' + FirebaseToken
            }),
            body: JSON.stringify(bodyData)
        };

        return fetch(APIBaseUrl + 'profiles/allProfilesPagination', APIoptions);
    },

    getAllProfiles: function (FirebaseToken, collectionName) {
        const APIoptions = {
            method: 'GET',
            headers: new Headers({
                Accept: 'application/json',
                'Content-Type': 'application/json',
                Authorization: 'Bearer ' + FirebaseToken
            })
        };

        return fetch(
            APIBaseUrl +
                'profiles/allProfiles?collectionName=' +
                collectionName,
            APIoptions
        );
    },

    getAllUsers: function (FirebaseToken, bodyData) {
        const APIoptions = {
            method: 'POST',
            headers: new Headers({
                Accept: 'application/json',
                'Content-Type': 'application/json',
                Authorization: 'Bearer ' + FirebaseToken
            }),
            body: JSON.stringify(bodyData)
        };

        return fetch(APIBaseUrl + 'profiles/getAllUsers', APIoptions);
    },

    getAllApprovedProfiles: function (FirebaseToken, collectionName) {
        const APIoptions = {
            method: 'GET',
            headers: new Headers({
                Accept: 'application/json',
                'Content-Type': 'application/json',
                Authorization: 'Bearer ' + FirebaseToken
            })
        };

        return fetch(
            APIBaseUrl +
                'profiles/allActiveProfiles?collectionName=' +
                collectionName,
            APIoptions
        );
    },
    getProfileDetail: function (FirebaseToken, bodyData) {
        const APIoptions = {
            method: 'POST',
            headers: new Headers({
                Accept: 'application/json',
                'Content-Type': 'application/json',
                Authorization: 'Bearer ' + FirebaseToken
            }),
            body: JSON.stringify(bodyData)
        };
        return fetch(APIBaseUrl + 'profiles/profileDetail', APIoptions);
    },
    getProfileBalance: function (FirebaseToken, bodyData) {
        const APIoptions = {
            method: 'POST',
            headers: new Headers({
                Accept: 'application/json',
                'Content-Type': 'application/json',
                Authorization: 'Bearer ' + FirebaseToken
            }),
            body: JSON.stringify(bodyData)
        };
        return fetch(APIBaseUrl + 'profiles/getProfileBalance', APIoptions);
    },

    deleteProfileDetail: function (FirebaseToken, bodyData) {
        const APIoptions = {
            method: 'POST',
            headers: new Headers({
                Accept: 'application/json',
                'Content-Type': 'application/json',
                Authorization: 'Bearer ' + FirebaseToken
            }),
            body: JSON.stringify(bodyData)
        };
        return fetch(APIBaseUrl + 'profiles/deleteProfileDetail', APIoptions);
    },

    /*
    updateAllProfiles: function(FirebaseToken) {
            const APIoptions = { 
            method: 'GET',
            headers: new Headers({
          	'Accept': 'application/json',
          	'Content-Type': 'application/json',
          	'Authorization': 'Bearer ' + FirebaseToken,
        	})
        	}
        	return fetch(APIBaseUrl+'profiles/updateAllProfiles', APIoptions)
    },
    */

    setPrimaryBank: function (FirebaseToken, bodyData) {
        const APIoptions = {
            method: 'POST',
            headers: new Headers({
                Accept: 'application/json',
                'Content-Type': 'application/json',
                Authorization: 'Bearer ' + FirebaseToken
            }),
            body: JSON.stringify(bodyData)
        };
        return fetch(APIBaseUrl + 'profiles/setPrimaryBank', APIoptions);
    },

    deleteBank: function (FirebaseToken, bodyData) {
        const APIoptions = {
            method: 'POST',
            headers: new Headers({
                Accept: 'application/json',
                'Content-Type': 'application/json',
                Authorization: 'Bearer ' + FirebaseToken
            }),
            body: JSON.stringify(bodyData)
        };
        return fetch(APIBaseUrl + 'profiles/deleteBank', APIoptions);
    },

    AddProfile: function (FirebaseToken, bodyData) {
        const APIoptions = {
            method: 'POST',
            headers: new Headers({
                Accept: 'application/json',
                'Content-Type': 'application/json',
                Authorization: 'Bearer ' + FirebaseToken
            }),
            body: JSON.stringify(bodyData)
        };
        return fetch(APIBaseUrl + 'profiles/addProfile', APIoptions);
    },

    signUpStoreOwners: function (bodyData) {
        const APIoptions = {
            method: 'POST',
            headers: new Headers({
                Accept: 'application/json',
                'Content-Type': 'application/json'
            }),
            body: JSON.stringify(bodyData)
        };
        return fetch(APIBaseUrl + 'profiles/signUpStoreOwners', APIoptions);
    },

    EditProfile: function (FirebaseToken, bodyData) {
        const APIoptions = {
            method: 'POST',
            headers: new Headers({
                Accept: 'application/json',
                'Content-Type': 'application/json',
                Authorization: 'Bearer ' + FirebaseToken
            }),
            body: JSON.stringify(bodyData)
        };
        return fetch(APIBaseUrl + 'profiles/editProfile', APIoptions);
    },

    addNewBankAccount: function (FirebaseToken, bodyData) {
        const APIoptions = {
            method: 'POST',
            headers: new Headers({
                Accept: 'application/json',
                'Content-Type': 'application/json',
                Authorization: 'Bearer ' + FirebaseToken
            }),
            body: JSON.stringify(bodyData)
        };
        return fetch(APIBaseUrl + 'profiles/addNewBankAccount', APIoptions);
    },

    createOrderCSV: function (FirebaseToken, bodyData) {
        const APIoptions = {
            method: 'POST',
            headers: new Headers({
                Accept: 'application/json',
                'Content-Type': 'application/json',
                Authorization: 'Bearer ' + FirebaseToken
            }),
            body: JSON.stringify(bodyData)
        };

        return fetch(APIBaseUrl + 'profiles/createOrderCSV', APIoptions);
    },

    loadOrderSheetsData: function (FirebaseToken, UniqeID) {
        const APIoptions = {
            method: 'GET',
            headers: new Headers({
                Accept: 'application/json',
                'Content-Type': 'application/json',
                Authorization: 'Bearer ' + FirebaseToken
            })
        };

        return fetch(
            APIBaseUrl + 'profiles/loadOrderSheetsData?UniqeID=' + UniqeID,
            APIoptions
        );
    },

    addEditStoreTagMapping: function (FirebaseToken, bodyData) {
        const APIoptions = {
            method: 'POST',
            headers: new Headers({
                Accept: 'application/json',
                'Content-Type': 'application/json',
                Authorization: 'Bearer ' + FirebaseToken
            }),
            body: JSON.stringify(bodyData)
        };
        return fetch(
            APIBaseUrl + 'profiles/addEditStoreTagMapping',
            APIoptions
        );
    },

    updateStoreTagMapping: function (FirebaseToken, bodyData) {
        const APIoptions = {
            method: 'POST',
            headers: new Headers({
                Accept: 'application/json',
                'Content-Type': 'application/json',
                Authorization: 'Bearer ' + FirebaseToken
            }),
            body: JSON.stringify(bodyData)
        };
        return fetch(APIBaseUrl + 'profiles/updateStoreTagMapping', APIoptions);
    },

    bulkImportStoreOwners: function (FirebaseToken, bodyData) {
        const APIoptions = {
            method: 'POST',
            headers: new Headers({
                Accept: 'application/json',
                'Content-Type': 'application/json',
                Authorization: 'Bearer ' + FirebaseToken
            }),
            body: JSON.stringify(bodyData)
        };
        return fetch(APIBaseUrl + 'profiles/bulkImportStoreOwners', APIoptions);
    },

    forecBulkImportStoreOwners: function (FirebaseToken, bodyData) {
        const APIoptions = {
            method: 'POST',
            headers: new Headers({
                Accept: 'application/json',
                'Content-Type': 'application/json',
                Authorization: 'Bearer ' + FirebaseToken
            }),
            body: JSON.stringify(bodyData)
        };
        return fetch(
            APIBaseUrl + 'profiles/forceBulkImportStoreOwners',
            APIoptions
        );
    },

    getSignInUserDetail: function (FirebaseToken, bodyData) {
        const APIoptions = {
            method: 'POST',
            headers: new Headers({
                Accept: 'application/json',
                'Content-Type': 'application/json',
                Authorization: 'Bearer ' + FirebaseToken
            }),
            body: JSON.stringify(bodyData)
        };

        return fetch(APIBaseUrl + 'profiles/getSignInUserDetail', APIoptions);
    },

    getGiftCardsStatus: function (FirebaseToken, bodyData) {
        const APIoptions = {
            method: 'POST',
            headers: new Headers({
                Accept: 'application/json',
                'Content-Type': 'application/json',
                Authorization: 'Bearer ' + FirebaseToken
            }),
            body: JSON.stringify(bodyData)
        };

        return fetch(APIBaseUrl + 'profiles/getGiftCardsStatus', APIoptions);
    },
    getAssignedGiftCards: function (FirebaseToken, bodyData) {
        const APIoptions = {
            method: 'POST',
            headers: new Headers({
                Accept: 'application/json',
                'Content-Type': 'application/json',
                Authorization: 'Bearer ' + FirebaseToken
            }),
            body: JSON.stringify(bodyData)
        };

        return fetch(APIBaseUrl + 'profiles/getAssignedGiftCards', APIoptions);
    },
    updateAssignedGiftCards: function (FirebaseToken, bodyData) {
        const APIoptions = {
            method: 'POST',
            headers: new Headers({
                Accept: 'application/json',
                'Content-Type': 'application/json',
                Authorization: 'Bearer ' + FirebaseToken
            }),
            body: JSON.stringify(bodyData)
        };

        return fetch(
            APIBaseUrl + 'profiles/updateAssignedGiftCards',
            APIoptions
        );
    },

    /***** Orders Section Start Here **************/

    fetchCollection: function (FirebaseToken, bodyData) {
        const APIoptions = {
            method: 'POST',
            headers: new Headers({
                Accept: 'application/json',
                'Content-Type': 'application/json',
                Authorization: 'Bearer ' + FirebaseToken
            }),
            body: JSON.stringify(bodyData)
        };
        return fetch(APIBaseUrl + 'orders/fetchCollection', APIoptions);
    },
    fetchCollectionInArray: function (FirebaseToken, bodyData) {
        const APIoptions = {
            method: 'POST',
            headers: new Headers({
                Accept: 'application/json',
                'Content-Type': 'application/json',
                Authorization: 'Bearer ' + FirebaseToken
            }),
            body: JSON.stringify(bodyData)
        };
        return fetch(APIBaseUrl + 'orders/fetchCollectionInArray', APIoptions);
    },
    fetchStoreTagsEarnings: function (FirebaseToken, bodyData) {
        const APIoptions = {
            method: 'POST',
            headers: new Headers({
                Accept: 'application/json',
                'Content-Type': 'application/json',
                Authorization: 'Bearer ' + FirebaseToken
            }),
            body: JSON.stringify(bodyData)
        };
        return fetch(APIBaseUrl + 'orders/fetchStoreTagsEarnings', APIoptions);
    },

    fetchStoreTagsEarningsPaginate: function (FirebaseToken, bodyData) {
        const APIoptions = {
            method: 'POST',
            headers: new Headers({
                Accept: 'application/json',
                'Content-Type': 'application/json',
                Authorization: 'Bearer ' + FirebaseToken
            }),
            body: JSON.stringify(bodyData)
        };
        return fetch(
            APIBaseUrl + 'orders/fetchStoreTagsEarningsPaginate',
            APIoptions
        );
    },

    fetchStoreStatics: function (FirebaseToken, bodyData) {
        const APIoptions = {
            method: 'POST',
            headers: new Headers({
                Accept: 'application/json',
                'Content-Type': 'application/json',
                Authorization: 'Bearer ' + FirebaseToken
            }),
            body: JSON.stringify(bodyData)
        };
        return fetch(APIBaseUrl + 'orders/fetchStoreStatics', APIoptions);
    },

    updateStoreStatics: function (FirebaseToken, bodyData) {
        const APIoptions = {
            method: 'POST',
            headers: new Headers({
                Accept: 'application/json',
                'Content-Type': 'application/json',
                Authorization: 'Bearer ' + FirebaseToken
            }),
            body: JSON.stringify(bodyData)
        };
        return fetch(APIBaseUrl + 'orders/updateStoreStatics', APIoptions);
    },
    getCashedStoreStatics: function (FirebaseToken, bodyData) {
        const APIoptions = {
            method: 'POST',
            headers: new Headers({
                Accept: 'application/json',
                'Content-Type': 'application/json',
                Authorization: 'Bearer ' + FirebaseToken
            }),
            body: JSON.stringify(bodyData)
        };
        return fetch(APIBaseUrl + 'orders/getCashedStoreStatics', APIoptions);
    },

    thisMonthlyStoreStatics: function (FirebaseToken, bodyData) {
        const APIoptions = {
            method: 'POST',
            headers: new Headers({
                Accept: 'application/json',
                'Content-Type': 'application/json',
                Authorization: 'Bearer ' + FirebaseToken
            }),
            body: JSON.stringify(bodyData)
        };
        return fetch(APIBaseUrl + 'orders/thisMonthlyStoreStatics', APIoptions);
    },
    fetchCategoryStatics: function (FirebaseToken, bodyData) {
        const APIoptions = {
            method: 'POST',
            headers: new Headers({
                Accept: 'application/json',
                'Content-Type': 'application/json',
                Authorization: 'Bearer ' + FirebaseToken
            }),
            body: JSON.stringify(bodyData)
        };
        return fetch(APIBaseUrl + 'orders/fetchCategoryStatics', APIoptions);
    },

    fetchAllStatics: function (FirebaseToken, bodyData) {
        const APIoptions = {
            method: 'POST',
            headers: new Headers({
                Accept: 'application/json',
                'Content-Type': 'application/json',
                Authorization: 'Bearer ' + FirebaseToken
            }),
            body: JSON.stringify(bodyData)
        };
        return fetch(APIBaseUrl + 'orders/fetchAllStatics', APIoptions);
    },
    fetchMyDashboardStatics: function (FirebaseToken, bodyData) {
        const APIoptions = {
            method: 'POST',
            headers: new Headers({
                Accept: 'application/json',
                'Content-Type': 'application/json',
                Authorization: 'Bearer ' + FirebaseToken
            }),
            body: JSON.stringify(bodyData)
        };
        return fetch(APIBaseUrl + 'orders/fetchMyDashboardStatics', APIoptions);
    },
    checkMyDashboardStatics: function (FirebaseToken, bodyData) {
        const APIoptions = {
            method: 'POST',
            headers: new Headers({
                Accept: 'application/json',
                'Content-Type': 'application/json',
                Authorization: 'Bearer ' + FirebaseToken
            }),
            body: JSON.stringify(bodyData)
        };
        return fetch(APIBaseUrl + 'orders/checkMyDashboardStatics', APIoptions);
    },

    fetchMyDashboardCustomStatics: function (FirebaseToken, bodyData) {
        const APIoptions = {
            method: 'POST',
            headers: new Headers({
                Accept: 'application/json',
                'Content-Type': 'application/json',
                Authorization: 'Bearer ' + FirebaseToken
            }),
            body: JSON.stringify(bodyData)
        };
        return fetch(
            APIBaseUrl + 'orders/fetchMyDashboardCustomStatics',
            APIoptions
        );
    },

    getFeeOrdersLastUpdate: function (FirebaseToken) {
        const APIoptions = {
            method: 'GET',
            headers: new Headers({
                Accept: 'application/json',
                'Content-Type': 'application/json',
                Authorization: 'Bearer ' + FirebaseToken
            })
        };
        return fetch(APIBaseUrl + 'orders/getFeeOrdersLastUpdate', APIoptions);
    },

    // Get Top Sellers Data //

    getTopSellers: function (FirebaseToken, bodyData) {
        const APIoptions = {
            method: 'POST',
            headers: new Headers({
                Accept: 'application/json',
                'Content-Type': 'application/json',
                Authorization: 'Bearer ' + FirebaseToken
            }),
            body: JSON.stringify(bodyData)
        };
        return fetch(APIBaseUrl + 'orders/getTopSellers', APIoptions);
    },

    getAllCategory: function (FirebaseToken, bodyData) {
        const APIoptions = {
            method: 'POST',
            headers: new Headers({
                Accept: 'application/json',
                'Content-Type': 'application/json',
                Authorization: 'Bearer ' + FirebaseToken
            }),
            body: JSON.stringify(bodyData)
        };
        return fetch(APIBaseUrl + 'orders/getAllCategory', APIoptions);
    },

    /***** Traing Section Start Here **************/

    getVideosLanguages: function (FirebaseToken) {
        const APIoptions = {
            method: 'GET',
            headers: new Headers({
                Accept: 'application/json',
                'Content-Type': 'application/json',
                Authorization: 'Bearer ' + FirebaseToken
            })
        };
        return fetch(APIBaseUrl + 'training/getVideosLanguages', APIoptions);
    },
    getVideoLinks: function (FirebaseToken, language) {
        const APIoptions = {
            method: 'GET',
            headers: new Headers({
                Accept: 'application/json',
                'Content-Type': 'application/json',
                Authorization: 'Bearer ' + FirebaseToken
            })
        };
        return fetch(
            APIBaseUrl + 'training/getVideoLinks?language=' + language,
            APIoptions
        );
    },

    // Notifications Start here.....

    getAllNotifications: function (FirebaseToken, bodyData) {
        const APIoptions = {
            method: 'POST',
            headers: new Headers({
                Accept: 'application/json',
                'Content-Type': 'application/json',
                Authorization: 'Bearer ' + FirebaseToken
            }),
            body: JSON.stringify(bodyData)
        };
        return fetch(
            APIBaseUrl + 'notification/getAllNotifications',
            APIoptions
        );
    },

    applyNotificationFilter: function (FirebaseToken, bodyData) {
        const APIoptions = {
            method: 'POST',
            headers: new Headers({
                Accept: 'application/json',
                'Content-Type': 'application/json',
                Authorization: 'Bearer ' + FirebaseToken
            }),
            body: JSON.stringify(bodyData)
        };
        return fetch(
            APIBaseUrl + 'notification/applyNotificationFilter',
            APIoptions
        );
    },
    SendNotification: function (FirebaseToken, bodyData) {
        const APIoptions = {
            method: 'POST',
            headers: new Headers({
                Accept: 'application/json',
                'Content-Type': 'application/json',
                Authorization: 'Bearer ' + FirebaseToken
            }),
            body: JSON.stringify(bodyData)
        };
        return fetch(APIBaseUrl + 'notification/SendNotification', APIoptions);
    },

    getAllSales: function (FirebaseToken) {
        const APIoptions = {
            method: 'GET',
            headers: new Headers({
                Accept: 'application/json',
                'Content-Type': 'application/json',
                Authorization: 'Bearer ' + FirebaseToken
            })
        };
        return fetch(APIBaseUrl + 'notification/getAllSales', APIoptions);
    },

    getUpcommingSales: function (FirebaseToken) {
        const APIoptions = {
            method: 'GET',
            headers: new Headers({
                Accept: 'application/json',
                'Content-Type': 'application/json',
                Authorization: 'Bearer ' + FirebaseToken
            })
        };
        return fetch(APIBaseUrl + 'notification/getUpcommingSales', APIoptions);
    },

    addEditSale: function (FirebaseToken, bodyData) {
        const APIoptions = {
            method: 'POST',
            headers: new Headers({
                Accept: 'application/json',
                'Content-Type': 'application/json',
                Authorization: 'Bearer ' + FirebaseToken
            }),
            body: JSON.stringify(bodyData)
        };
        return fetch(APIBaseUrl + 'notification/addEditSale', APIoptions);
    },

    // Notifications End here.....

    updateDashboardDataOLD: function (FirebaseToken, bodyData) {
        const APIoptions = {
            method: 'GET',
            headers: new Headers({
                Accept: 'application/json',
                'Content-Type': 'application/json',
                Authorization: 'Bearer ' + FirebaseToken
            })
        };
        return fetch(APIBaseUrl + 'migration/usersDashboardData', APIoptions);
    },

    updateDashboardData: function (FirebaseToken, bodyData) {
        const APIoptions = {
            method: 'POST',
            headers: new Headers({
                Accept: 'application/json',
                'Content-Type': 'application/json',
                Authorization: 'Bearer ' + FirebaseToken
            }),
            body: JSON.stringify(bodyData)
        };
        return fetch(
            APIBaseUrl + 'migration/usersDashboardDataPOst',
            APIoptions
        );
    },

    /// Manual Migration
    syncAllProfiles: function (FirebaseToken) {
        const APIoptions = {
            method: 'GET',
            headers: new Headers({
                Accept: 'application/json',
                'Content-Type': 'application/json',
                Authorization: 'Bearer ' + FirebaseToken
            })
        };

        return fetch(APIBaseUrl + 'import/syncAllProfiles', APIoptions);
    },
    exportChannelPartnerDoc: function (FirebaseToken) {
        const APIoptions = {
            method: 'GET',
            headers: new Headers({
                Accept: 'application/json',
                'Content-Type': 'application/json',
                Authorization: 'Bearer ' + FirebaseToken
            })
        };
        return fetch(APIBaseUrl + 'export/exportChannelPartnerDoc', APIoptions);
    },
    importStoreCP: function (FirebaseToken, bodyData) {
        const APIoptions = {
            method: 'POST',
            headers: new Headers({
                Accept: 'application/json',
                'Content-Type': 'application/json',
                Authorization: 'Bearer ' + FirebaseToken
            }),
            body: JSON.stringify(bodyData)
        };
        return fetch(APIBaseUrl + 'import/importStoreCP', APIoptions);
    },

    exportStoreOwnerDoc: function (FirebaseToken) {
        const APIoptions = {
            method: 'GET',
            headers: new Headers({
                Accept: 'application/json',
                'Content-Type': 'application/json',
                Authorization: 'Bearer ' + FirebaseToken
            })
        };
        return fetch(APIBaseUrl + 'export/exportStoreOwnerDoc', APIoptions);
    },

    importStoreOwners: function (FirebaseToken, bodyData) {
        const APIoptions = {
            method: 'POST',
            headers: new Headers({
                Accept: 'application/json',
                'Content-Type': 'application/json',
                Authorization: 'Bearer ' + FirebaseToken
            }),
            body: JSON.stringify(bodyData)
        };
        return fetch(APIBaseUrl + 'import/importStoreOwners', APIoptions);
    },

    exportMappingHistory: function (FirebaseToken) {
        const APIoptions = {
            method: 'GET',
            headers: new Headers({
                Accept: 'application/json',
                'Content-Type': 'application/json',
                Authorization: 'Bearer ' + FirebaseToken
            })
        };
        return fetch(APIBaseUrl + 'import/exportMappingHistory', APIoptions);
    },
    updateMappingHistory: function (FirebaseToken, bodyData) {
        const APIoptions = {
            method: 'POST',
            headers: new Headers({
                Accept: 'application/json',
                'Content-Type': 'application/json',
                Authorization: 'Bearer ' + FirebaseToken
            }),
            body: JSON.stringify(bodyData)
        };
        return fetch(APIBaseUrl + 'import/updateMappingHistory', APIoptions);
    }
};

export default RestServices;
